import React, { useEffect } from 'react';
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from '../../application/ApplicationContext';
import './ParticipantCompanyOverviewPage.scss';

const ParticipantCompanyOverviewPage = () => {

    const { setBreadcrumb } = useApplicationContext();

    useEffect(() => {
        setBreadcrumb(['Učesnici', 'Lista pravnih lica', 'Profil pravnog lica']);
    }, []);

    return (
        <PageLayout>
            <div className="participant-company-overview">
                PREGLED PODATAKA O KOMPANIJI UČESNIKU
            </div>
        </PageLayout>
    );
};

export default ParticipantCompanyOverviewPage;
